<template>
    <v-btn
        class="white--text ma-4"
        color="light-blue darken-4"
        to="/resume"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.cardAccountDetails }}</v-icon>
        <span class="ml-2">View Resume</span>
    </v-btn>
</template>

<script>
import { mdiCardAccountDetails } from '@mdi/js'

export default {
    name: 'ResumeResumeButton',
    data() {
        return {
            icons: {
                cardAccountDetails: mdiCardAccountDetails,
            },
        }
    },
}
</script>

<style scoped>

</style>